import { render, staticRenderFns } from "./CustomerCurrentInfo.vue?vue&type=template&id=12f83ab7&"
import script from "./CustomerCurrentInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerCurrentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports